/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPromotionalBalanceGetResponseFromDiscriminatorValue, serializePromotionalBalancePostRequest, type PromotionalBalanceGetResponse, type PromotionalBalancePostRequest } from '../../../models';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /creditcards/{creditCardId}/promotionalbalances
 */
export interface PromotionalbalancesRequestBuilder extends BaseRequestBuilder<PromotionalbalancesRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PromotionalBalanceGetResponse[]>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<PromotionalBalanceGetResponse[] | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     */
     post(body: PromotionalBalancePostRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Guid | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: PromotionalBalancePostRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const PromotionalbalancesRequestBuilderUriTemplate = "{+baseurl}/creditcards/{creditCardId}/promotionalbalances";
/**
 * Metadata for all the requests in the request builder.
 */
export const PromotionalbalancesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: PromotionalbalancesRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createPromotionalBalanceGetResponseFromDiscriminatorValue,
    },
    post: {
        uriTemplate: PromotionalbalancesRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializePromotionalBalancePostRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
